import {setLocaleConfigurations} from 'core/localization/config'
import {TranslationsList} from 'core/localization/types'
import {locales} from '../utils/localization'
import {englishLocales} from '../app/front-office/locales/en'
import {arabicLocales} from '../app/front-office/locales/ar'

const translations: TranslationsList = {
  en: englishLocales,
  ar: arabicLocales,
}


setLocaleConfigurations({
  defaultLocaleCode: import.meta.env.VITE_APP_DEFAULT_LOCALE_CODE,
  locales,
  translations,
})
